import LoginContainer from "components/Login/Login.container";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import { onceLoginUUIDAtom } from "src/atoms";
import { useLogIn } from "src/hooks/api/auth/useLogin";
import { useRouter } from "src/hooks/useRouter";
import { logout } from "src/service/sessions";

const LoginPage = () => {
  const { params } = useRouter();
  const [searchParams, setSearchParams] = useSearchParams();
  const { mutateOnceLogin } = useLogIn({ isOnceLogin: true });
  const [onceLoginUUID, setOnceLoginUUID] = useRecoilState(onceLoginUUIDAtom);
  // ~/login/123123 으로 요청 시 uuid 기반 로그인 요청
  // console.log("params", params);
  useEffect(() => {
    console.log("params", params);
    // console.log("search", searchParams.get("site"));
    async function init() {
      const isSite = searchParams.get("site") ?? null;
      const uuid: string = params.uuid ?? "";

      if (params.uuid && params.uuid !== "") {
        setOnceLoginUUID(params.uuid);
        await logout(true)
          .then(async () => {
            // console.log("lougout", uuid);
            await mutateOnceLogin({ uuid, site: isSite });
          })
          .catch((err) => {
            console.log("logout 실패", err);
            // console.log(handleErrorMsgMapper(err));
          });
      }
    }
    init();
  }, []);
  if (params.uuid && params.uuid !== "") return <></>;
  else return <LoginContainer />;
};

export default LoginPage;
